import {NavLink} from "react-router-dom";
import React from "react";
import '../css/fonts.css';

export const Navigation= () => (
    <>
        <div className={"title"}>
            <img className={"gallery-logo"} src={require('../logo/logo-square.jpg')}  alt='Logo'/>
            <div>
                <h1 className={"navbar-greeting"} style={{fontFamily: "Papyrus-fantasy"}}>Welcome to my art gallery 🖤</h1><br/>
                <h4 className={"navbar-greeting"} style={{fontFamily: "Art-gallery-Osaka", letterSpacing: "-0.13rem"}}>こんにちは〜&nbsp;私の美術を見ていただけて嬉しいです。&nbsp;ʚ(╹ڡ╹)ɞ</h4>
            </div>
        </div>
    </>
)